import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { StatusMessage } from '@elseu/sdu-titan';
import { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { getSectionSpacing } from '../../sections/Section/Section.js';
import { createSlug } from '../../utilities/createSlug/createSlug.js';
import { getSessionStorage, setSessionStorage } from '../../utilities/storage/storage.js';

var ToastContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isShown = _a.isShown;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), isShown && getSectionSpacing({
    theme: theme,
    yPadding: 4,
    xPadding: [4, 8, 12, 24]
  }));
});
var Toast = function (_a) {
  var name = _a.name,
    children = _a.children;
  var _b = useState(false),
    isShown = _b[0],
    setIsShown = _b[1];
  var handleClose = function () {
    setIsShown(false);
    if (name && typeof window !== 'undefined') {
      setSessionStorage("sdu-toast-closed-".concat(createSlug(name)), 'true');
    }
  };
  useEffect(function () {
    if (name && typeof window !== 'undefined') {
      var isToastClosed = getSessionStorage("sdu-toast-closed-".concat(createSlug(name)));
      return setIsShown(isToastClosed !== 'true');
    }
    setIsShown(true);
  }, [name]);
  return jsx(ToastContainer, {
    isShown: isShown,
    children: jsx(StatusMessage, {
      type: "warning",
      isRounded: true,
      isCloseable: true,
      isShown: isShown,
      onClose: handleClose,
      children: children
    })
  });
};
var templateObject_1, templateObject_2;

export { Toast };
//# sourceMappingURL=Toast.js.map
